export const legal_pt_Translation = {
  terms_and_conditions: {
    title: "Termos e Condições",
    intro:
      "Este Acordo de Licença de Usuário Final é um contrato válido entre Você e a Empresa. Por favor, leia este EULA cuidadosamente. As regras do EULA são vinculativas para Você. Se Você não concorda em estar vinculado às regras do EULA, por favor, não utilize o WebApp. Se continuar a usar o WebApp, isso significará que Você leu e entendeu o EULA e concorda em estar vinculado a ele.",
    definitions: {
      title: "1. DEFINIÇÕES E TERMOS",
      description:
        "Para compreender claramente as regras do EULA, você deve familiarizar-se com o significado dos termos utilizados no EULA. Neste EULA, os seguintes termos, quando capitalizados, terão os seguintes significados:",
      definitions_list: {
        account:
          "“Conta” – significa uma conta pessoal de um usuário dos serviços da Plataforma, fornecida pelo Administrador da Plataforma conforme os Termos de Uso da Plataforma ou documento semelhante. A Conta é acessada com um ID da Plataforma (nome da conta) e uma senha.",
        company:
          "“Empresa”, “Nós” – significam WEBFY, uma empresa incorporada na Irlanda no seguinte endereço: Black Church, St Mary’s Place, Dublin D07 P4AX, Irlanda.",
        content:
          "“Conteúdo” – significa todos os tipos de conteúdo, incluindo, entre outros, dados, textos, imagens, vídeos, sons, links, softwares e outras informações em qualquer formato, que são disponibilizados a Você por meio do WebApp.",
        device:
          "“Dispositivo” – significa um smartphone, tablet ou outro dispositivo móvel semelhante que Você possua ou controle legalmente exclusivamente para seu uso pessoal e não comercial.",
        eula: "“EULA” – significa este Acordo de Licença de Usuário Final, que é um contrato vinculativo entre Você e a Empresa. O EULA pode incorporar outros documentos, como a Política de Privacidade, que regulamentam as relações entre Você e Nós em relação ao uso do WebApp. Se um documento representar parte do EULA, terá uma indicação clara disso.",
        intellectual_property_rights:
          "“Direitos de Propriedade Intelectual” – significam, coletivamente, direitos sob qualquer lei de patente, marca registrada, direito autoral e segredo comercial, e quaisquer outros direitos de propriedade intelectual ou direitos proprietários reconhecidos em qualquer país ou jurisdição em todo o mundo, incluindo, sem limitação, direitos morais ou similares.",
        subscription:
          "“Assinatura” – significa um período durante o qual Você utiliza o WebApp como um todo ou determinado Conteúdo adicional mediante pagamento de uma taxa.",
        user_generated_content:
          "“Conteúdo Gerado pelo Usuário” – significa qualquer forma de Conteúdo, incluindo, entre outros, dados, textos, imagens, vídeos, sons, links, que tenham sido publicados por usuários em plataformas online, por exemplo, redes sociais (como Instagram, Facebook).",
        you: "“Você” – significa uma pessoa que utiliza o WebApp.",
      },
    },
    changes_of_eula: {
      title: "2. ALTERAÇÕES DO EULA",
      list: {
        changes_intro:
          "Podemos introduzir alterações neste EULA de tempos em tempos. Você deve verificar regularmente a versão mais recente do EULA no link disponível na página da web.",
        changes_effective:
          "Se Você não concorda com os termos do EULA atualizado, Você não tem permissão para usar o WebApp a partir do dia em que o EULA atualizado entra em vigor. Nesse caso, Você deve parar de usar o WebApp e cancelar a renovação de suas Assinaturas.",
      },
    },
    device: {
      title: "3. DISPOSITIVO",
      list: {
        use_non_owned_device:
          "Se Você pretende usar o WebApp em qualquer Dispositivo que não seja de sua propriedade, deve ter permissão do proprietário para fazê-lo. Você será responsável por cumprir este EULA, independentemente de ser ou não o proprietário do Dispositivo.",
        access_to_non_owned_device:
          "Se Você não é o proprietário do Dispositivo, está autorizado a usar o WebApp apenas através de sua Conta.",
        responsibility:
          "Se Você usa o Dispositivo junto com outras pessoas, por favor, certifique-se de que ninguém, exceto Você, possa usar o WebApp a partir de sua Conta. Todas as ações realizadas na sua Conta são consideradas suas ações, independentemente de quem realmente as realiza. Você é totalmente responsável por todas as ações realizadas na sua Conta.",
        removal:
          "Se Você decidir vender ou de alguma forma se desfazer do Dispositivo, deverá excluir o WebApp do Dispositivo.",
      },
    },
    capacity_and_age: {
      title: "4. CAPACIDADE LEGAL E IDADE",
      list: {
        over_16:
          "O WebApp é destinado a usuários com mais de 16 anos. Se Você usar o WebApp, confirma que tem pelo menos 16 anos e possui plena capacidade legal para celebrar este Contrato.",
        between_16_18:
          "Se Você tiver entre 16 e 18 anos, seu pai, responsável ou outro representante legal deve ler e concordar com este EULA em seu nome. Se Você usar o WebApp, confirma que seu pai, responsável ou outro representante legal concordou com os termos deste EULA e permite que Você use o WebApp.",
      },
    },
    intellectual_property: {
      title: "5. PROPRIEDADE INTELECTUAL",
      list: {
        license_grant_and_webapp_use_terms:
          "Concedemos a Você uma licença não exclusiva, pessoal, limitada, revogável e intransferível para acessar, baixar e executar o WebApp apenas no Seu Dispositivo, desde que Você concorde em cumprir todos os termos e condições deste EULA. Por favor, considere que o WebApp é licenciado, e não vendido, a Você.",
        intellectual_property_rights_and_reservation_of_rights:
          "A Empresa ou o licenciante da Empresa é o único detentor dos Direitos de Propriedade Intelectual em relação ao WebApp. A Empresa mantém todos os direitos, título e interesse no WebApp e reserva todos os direitos não expressamente concedidos a Você neste EULA.",
        restrictions_on_transferring_rights_to_webapp:
          "Você não pode vender, revender, distribuir, redistribuir, alugar, arrendar, sublicenciar, ceder, copiar ou de qualquer outra forma transferir ou conceder quaisquer direitos ao WebApp a terceiros.",
        restrictions_on_network_distribution_and_access:
          "Você não pode distribuir ou tornar o WebApp disponível em qualquer rede onde ele possa ser baixado ou usado por vários usuários ao mesmo tempo, exceto quando expressamente autorizado por Nós.",
        prohibitions_on_interfering_with_webapp_functionality:
          "Você não pode usar qualquer dispositivo ou processo automático ou manual para interferir no funcionamento adequado do WebApp. No entanto, Você pode usar qualquer tipo de dispositivo ou processo para excluir o WebApp do Seu Dispositivo.",
        prohibitions_on_decompiling_and_reverse_engineering:
          "Você não pode descompilar, desmontar, realizar engenharia reversa ou criar obras derivadas do WebApp ou de qualquer parte dele. Todas as modificações ou melhorias no WebApp permanecem propriedade exclusiva da Empresa.",
        prohibitions_on_unlawful_use_and_malicious_activity:
          "Você não pode usar o WebApp de maneira ilegal, para qualquer propósito ilegal ou de forma inconsistente com este EULA, nem agir de forma fraudulenta ou maliciosa, por exemplo, invadindo ou inserindo códigos maliciosos, como vírus ou dados prejudiciais, no WebApp.",
      },
    },
    subscription_and_trial_period: {
      title: "6. ASSINATURA E PERÍODO DE TESTE",
      list: {
        subscription_basis_and_fee_variation:
          "Este WebApp como um todo ou certas partes (Conteúdo adicional) são fornecidos com base em assinatura paga. A taxa pode variar dependendo do período de duração da Assinatura.",
        automatic_renewal_and_account_charge:
          "A Assinatura será renovada automaticamente pelo mesmo período ao final da Assinatura, ao custo do pacote escolhido. Sua Conta será cobrada pela Assinatura renovada dentro de 24 horas antes do final da Assinatura atual.",
        cancellation_of_subscription_renewal:
          "Você pode cancelar a renovação da Assinatura pelo menos 24 horas antes do final da Assinatura: nesse caso, o WebApp como um todo ou seu Conteúdo adicional estará disponível para Você até o final da Assinatura. Para cancelar a renovação automática da Assinatura, altere as configurações de assinatura da Sua Conta. Após o término da Assinatura, o WebApp como um todo ou seu Conteúdo adicional estará disponível apenas se uma nova Assinatura for adquirida.",
        manual_cancellation_required:
          "Sua assinatura não será encerrada automaticamente. Você deve cancelar a renovação automática de Sua assinatura para não ser cobrado pelo custo da nova Assinatura.",
        free_trial_period_and_auto_conversion:
          "O WebApp oferece um período de teste gratuito de 7 dias. Você pode usar o WebApp ou seu Conteúdo adicional gratuitamente durante este período. Por favor, considere que, ao final do período de teste, ele se converterá automaticamente em uma Assinatura paga pelo menor período disponível e sua Conta será cobrada pelo custo dessa Assinatura, a menos que Você cancele a Assinatura nas configurações de assinatura da Sua Conta pelo menos 24 horas antes do término do período de teste gratuito.",
      },
    },
    fees_and_purchase_terms: {
      title: "7. TAXAS E TERMOS DE COMPRA",
      list: {
        subscription_costs_availability:
          "Os custos de todas as Assinaturas estão disponíveis na página da web.",
        payment_processing_by_platform_administrator:
          "Ao adquirir uma Assinatura, o Administrador da Plataforma cobra sua Conta e coleta o pagamento em Nosso nome. O pagamento é processado por um sistema de processamento de pagamento implementado pelo Administrador da Plataforma.",
        no_access_to_payment_information:
          "Por favor, observe que Nós não processamos Seu pagamento nem temos acesso a Suas informações de pagamento, como, entre outras, os dados do Seu cartão bancário, Seu nome ou qualquer outra informação relacionada.",
        questions_on_payment_processing:
          "Caso tenha alguma dúvida sobre o processamento de pagamento, envie Sua questão ao serviço de suporte ao usuário do Administrador da Plataforma.",
        account_charge_timing:
          "Sua Conta será cobrada com o valor da nova Assinatura dentro de 24 horas antes do final da Assinatura atual. Se Você cancelar a renovação automática nas últimas 24 horas da Assinatura, esse cancelamento entrará em vigor no final da nova Assinatura.",
        no_refunds_and_immediate_content_access:
          "Por favor, observe que não oferecemos reembolsos. O conteúdo digital é disponibilizado para Você imediatamente após a taxa de Assinatura ser cobrada de Sua Conta.",
      },
    },
    user_generated_content: {
      title: "8. CONTEÚDO GERADO PELO USUÁRIO",
      list: {
        exposure_to_objectionable_content:
          "Como Você pode acessar postagens de outros usuários do Instagram, pode estar exposto a Conteúdo Gerado pelo Usuário potencialmente inapropriado. Por favor, leve em consideração que a Empresa não controla nem pré-verifica qualquer Conteúdo Gerado pelo Usuário postado em qualquer rede social.",
        modifications_and_censorship:
          "Qualquer tipo de modificação ou censura por parte da Empresa em relação ao Conteúdo Gerado pelo Usuário pode ser considerada uma violação dos direitos humanos ou de direitos autorais e pode potencialmente induzir Você ao erro.",
        handling_objectionable_content:
          "Se Você foi exposto a qualquer tipo de conteúdo inapropriado, pode usar a funcionalidade da respectiva rede social para rastrear e excluir o Conteúdo Gerado pelo Usuário inapropriado.",
        company_disclaimer:
          "Em nenhuma circunstância a Empresa será responsável por qualquer Conteúdo Gerado pelo Usuário.",
      },
    },
    disclaimer: {
      title: "9. ISENÇÃO DE RESPONSABILIDADE",
      list: {
        general_disclaimer_of_warranties:
          "Na máxima extensão permitida pela legislação aplicável, Nós e Nossos afiliados, funcionários, agentes, parceiros e licenciadores renunciamos expressamente a todas as garantias de qualquer tipo, expressas ou implícitas, quanto à precisão, adequação ou completude de qualquer informação contida em Nosso WebApp ou criada pelos serviços.",
        content_provided_as_is:
          "O Conteúdo em Nosso WebApp é fornecido a Você em uma base “como está”, sem quaisquer garantias de comercialização ou adequação para um propósito ou uso específico. Não garantimos que Você alcançará qualquer resultado esperado com o uso do WebApp.",
        no_warranty_on_specifics: {
          title: "Não fazemos nenhuma garantia de que:",
          a: "o WebApp atenderá aos Seus requisitos;",
          b: "o WebApp estará livre de erros, será seguro ou ininterrupto;",
          c: "quaisquer erros de funcionalidade do WebApp serão corrigidos;",
          d: "a qualidade do WebApp atenderá às Suas expectativas.",
        },
        limitation_of_liability:
          "Não teremos qualquer responsabilidade por erros ou omissões. Não somos responsáveis por quaisquer danos, diretos ou indiretos, especiais ou consequenciais, sofridos por Você ou por qualquer outra pessoa pelo uso do WebApp, mesmo que Você tenha sido avisado da possibilidade de tais danos. Nenhum conselho ou informação, seja oral ou escrita, obtida por Você de Nós ou de Nosso WebApp criará qualquer garantia não expressamente declarada no EULA. Em nenhuma circunstância Nossa responsabilidade ou de qualquer um de Nossos afiliados, decorrente de qualquer causa de ação, seja em contrato, delito ou de outra forma, excederá a taxa paga por Você para acessar o WebApp. Além disso, não teremos qualquer responsabilidade por atrasos ou falhas devido a circunstâncias fora do Nosso controle.",
      },
    },
    transfer_of_rights: {
      title: "10. TRANSFERÊNCIA DE DIREITOS",
      list: {
        transfer_by_company:
          "Nós podemos transferir Nossos direitos e obrigações sob este EULA para qualquer outra organização ou indivíduo sem o Seu consentimento. Sempre informaremos Você por escrito se isso acontecer e garantiremos que a transferência não afetará Seus direitos sob o EULA.",
        transfer_by_user:
          "Você só pode transferir Seus direitos ou Suas obrigações sob este EULA para outra pessoa se Nós concordarmos por escrito.",
      },
    },
    termination_of_rights: {
      title: "11. RESCISÃO DE DIREITOS",
      list: {
        termination_for_breach:
          "Nós podemos encerrar Seus direitos de uso do WebApp a qualquer momento, entrando em contato com Você se Você tiver violado as regras deste EULA de maneira grave. Se o que Você fez puder ser corrigido, daremos uma oportunidade razoável para fazê-lo.",
        actions_upon_termination: {
          title: "Se Nós encerrarmos Seus direitos de uso do WebApp:",
          a: "Você deve interromper todas as atividades autorizadas por este EULA, incluindo o uso do WebApp.",
          b: "Você deve excluir ou remover o WebApp de todos os Dispositivos e destruir imediatamente todas as cópias do WebApp que possuir e confirmar para Nós que fez isso.",
        },
      },
    },
    miscellaneous: {
      title: "12. DISPOSIÇÕES GERAIS",
      list: {
        separation_of_paragraphs:
          "Cada parágrafo deste EULA opera separadamente. Se qualquer tribunal ou autoridade competente decidir que qualquer um deles é ilegal, os parágrafos restantes permanecerão em pleno vigor e efeito.",
        delay_in_enforcement:
          "Mesmo que Nós atrasemos a aplicação deste EULA, ainda podemos aplicá-lo mais tarde. Se Nós não insistirmos imediatamente que Você cumpra qualquer coisa que é exigida a Você sob os termos deste EULA, ou se Nós atrasarmos a adoção de medidas contra Você em relação à violação do EULA, isso não significará que Você não precisa cumprir essas obrigações e não impedirá que Nós tomemos medidas contra Você em uma data posterior.",
        governing_law:
          "Este EULA será regido e interpretado de acordo com as leis de Dublin, Irlanda, sem considerar suas disposições sobre conflito de leis.",
        dispute_resolution:
          "Se surgir qualquer disputa, controvérsia ou divergência entre Você e a Empresa, ela deverá ser resolvida amigavelmente através de negociações. Caso tal disputa, controvérsia ou divergência não possa ser resolvida amigavelmente através de negociações dentro de um período de 30 dias, será resolvida pela Associação de Arbitragem da Irlanda, de acordo com seus Procedimentos Internacionais Acelerados.",
        number_of_arbitrators: "O número de árbitros será um.",
        place_of_arbitrators: "O local da arbitragem será Dublin, Irlanda.",
        language_of_arbitrators:
          "A arbitragem será realizada e o prêmio concedido em inglês.",
        expense:
          "Cada parte (ou seja, Você e a Empresa) arcará com suas próprias despesas, mas as partes dividirão igualmente as despesas do tribunal de arbitragem.",
        support:
          "Suporte. Se Você quiser saber mais sobre o WebApp ou tiver algum problema ao usá-lo, entre em contato conosco em <tag>support@freelanz.app</tag>",
      },
    },
  },
  privacy_policy: {
    title: "Privacidade e Política",
    commitment_title: "Nosso Compromisso com Sua Privacidade",
    commitment_text:
      "Nós respeitamos e protegemos a privacidade dos usuários do nosso WebApp. Esta Política de Privacidade explica como coletamos e usamos suas informações e faz parte dos nossos Termos de Uso ao utilizar o nosso WebApp. Ao usar nosso WebApp e o serviço fornecido pelo WebApp (“Serviço”), você concorda com nossa Política de Privacidade. Se você não concordar, por favor, não use nosso WebApp.",
    info_collection_title: "Que informações coletamos?",
    info_collection_text:
      "Se você realizar compras ou adquirir uma assinatura, nossos provedores de serviços de cobrança terceirizados coletarão informações como seu nome completo, número do cartão de crédito e endereço de cobrança. Se você nos enviar um e-mail, podemos usar seu endereço de e-mail para responder ao seu e-mail. Informações Enviadas pelo Seu Dispositivo Móvel. Coletamos certas informações que seu dispositivo móvel envia quando você usa nosso WebApp, como um identificador de dispositivo, configurações do usuário e o sistema operacional do seu dispositivo, bem como informações sobre o uso de nossos Serviços. Informações de Localização. Quando você usa nosso WebApp, podemos coletar e armazenar informações sobre sua localização convertendo seu endereço IP em uma geolocalização aproximada ou acessando as coordenadas GPS ou localização aproximada do seu dispositivo móvel se você ativar os serviços de localização no seu dispositivo. Podemos usar informações de localização para melhorar e personalizar nossos Serviços para você. Se você não quiser que coletemos informações de localização, poderá desativar esse recurso no seu dispositivo móvel.",
    info_storage_title: "Onde armazenamos suas informações?",
    info_storage_text:
      "Suas informações podem ser armazenadas em nossos próprios servidores ou em servidores de provedores de armazenamento em nuvem terceirizados. Os provedores de armazenamento terceirizados não podem usar suas informações, exceto conforme previsto nesta Política de Privacidade.",
    info_usage_title: "Como usamos suas informações?",
    info_usage_text: "As informações que coletamos de você podem ser usadas:",
    info_storage_duration_title:
      "Por quanto tempo armazenamos suas informações?",
    info_storage_duration_text:
      "Pretendemos armazenar algumas de suas informações indefinidamente. E quanto aos links para outros sites? Podemos fornecer links ou compatibilidade com outros sites. No entanto, não somos responsáveis pelas práticas de privacidade empregadas por esses sites ou pelas informações ou conteúdo que eles contêm.",
    info_protection_title: "Como protegemos suas informações?",
    info_protection_text:
      "Usamos procedimentos físicos, eletrônicos e outros apropriados para proteger e proteger as informações que coletamos. No entanto, esteja ciente de que a Internet é um ambiente inerentemente inseguro e que hackers estão constantemente trabalhando para derrotar as medidas de segurança. Portanto, não podemos garantir que suas informações não serão acessadas, divulgadas, alteradas ou destruídas, e você aceita esse risco.",
    user_protection_title: "Como você pode proteger suas informações?",
    user_protection_text:
      "Incentivamos você a tomar medidas para manter suas informações pessoais seguras, não as compartilhando com outras pessoas ou postando-as online.",
    disclosure_title: "Divulgamos alguma informação a terceiros?",
    disclosure_text:
      "Não coletamos, vendemos, trocamos ou transferimos suas Informações Pessoais Identificáveis (IPI) para terceiros para fins comerciais ou de marketing, exceto conforme declarado neste documento. As informações pessoais (e informações não pessoais) coletadas através do Site podem ser compartilhadas com empresas e organizações que prestam serviços em nosso nome (por exemplo, empresas que fornecem gerenciamento de dados ou outros serviços de suporte para nós, como serviços de armazenamento de dados e hospedagem na web). Podemos compartilhar suas informações pessoais (e informações não pessoais) com terceiros para oferecer a você publicidade relevante e comercializar nossos produtos, mas não venderemos suas informações pessoais. Informações Divulgadas em Conexão com Transações Comerciais. Se formos adquiridos por um terceiro como resultado de uma transação como fusão, aquisição ou venda de ativos ou se nossos ativos forem adquiridos por um terceiro no caso de encerrarmos nossas atividades ou entrarmos em falência, alguns ou todos os nossos ativos, incluindo suas IPI, podem ser divulgados ou transferidos para o adquirente terceirizado em conexão com a transação. Informações Divulgadas para Nossa Proteção e Proteção de Outros. Cooperamos com autoridades governamentais e policiais ou partes privadas para aplicar e cumprir a lei. Podemos divulgar qualquer informação sobre você às autoridades governamentais ou policiais ou a partes privadas, conforme julguemos necessário ou apropriado, a nosso exclusivo critério: (i) para responder a reivindicações, processos legais (incluindo intimações); (ii) para proteger nossa propriedade, direitos e segurança e a propriedade, direitos e segurança de terceiros ou do público em geral; e (iii) para interromper qualquer atividade que consideremos ilegal, antiética ou passível de ação legal.",
    not_for_children_title: "Não Destinado a Crianças",
    not_for_children_text:
      "Nosso WebApp e Serviço não são destinados a crianças menores de 16 anos. Não coletamos intencionalmente ou especificamente informações de ou sobre crianças menores de 16 anos.",
    policy_changes_title: "Alterações em nossa Política de Privacidade",
    policy_changes_text:
      "Se decidirmos alterar nossa Política de Privacidade, publicaremos essas alterações nesta página. Podemos também, mas não somos obrigados, enviar-lhe um aviso por e-mail. Recomendamos que você revise esta política de privacidade com frequência para se manter informado sobre como estamos protegendo suas informações.",
    contact_title: "Entre em Contato Conosco",
    contact_text:
      "Se você tiver dúvidas sobre nossa Política de Privacidade, entre em contato conosco em <tag>support@freelanz.app</tag>",
  },
};

export const screens_pt_Translation = {
  common_text: {
    male: "Masculino",
    female: "Feminino",
    terms_and_conditions: "Termos e Condições",
    privacy_policy: "Política de Privacidade",
    copy_right: "Copyright ® 2024. Todos os Direitos Reservados.",
    continue: "Continuar",
    login_text: "ENTRAR",
  },
  landing_page: {
    title: "Cursos de IA Personalizados",
    personalized_freelance_plan: "Crie o seu caminho para a liberdade",
    start_freelance_business:
      "Comece um Negócio de Freelance: <tag/>Seja Seu Próprio Chefe",
    launch_successful_business:
      "Lance Seu Negócio de Freelance Bem-Sucedido Hoje",
    select_text: "Selecione seu gênero:",
  },
  career_plan: {
    title: "Plano de liberdade de carreira de acordo com a sua idade",
    age_18_24: "18-24",
    age_25_34: "25-34",
    age_35_44: "35-44",
    age_45_plus: "45+",
  },
  community: {
    title: "$36.000",
    sub_title: "pode ser onde seu empreendimento freelance começa",
  },
  goal_selection: {
    question: "Qual é o seu objetivo?",
    priority: "Por favor, selecione sua primeira prioridade",
    grow_wealth: "Aumentar a riqueza",
    be_boss: "Ser meu próprio chefe",
    travel_more: "Viajar mais",
    other: "Outro",
  },
  income_source: {
    question: "Qual é a sua fonte de renda atual?",
    job: "Emprego das 9 às 17",
    freelance: "Freelance",
    other: "Outro",
  },
  income_level: {
    question: "Escolha o seu nível de renda atual",
    low: "Baixo",
    medium: "Médio",
    high: "Alto",
  },
  financial_situation: {
    question: "Como você descreveria sua situação financeira?",
    struggling: "Estou lutando para alcançar meus objetivos financeiros",
    stability: "Gostaria de ter mais estabilidade",
    unsure: "Não tenho certeza",
    comfortable: "Estou confortável",
    range_30_50k: "$30.000-$50.000",
    range_50_100k: "$50.000-$100.000",
    range_above_100k: "Mais de $100.000",
  },
  remote_work: {
    question:
      "Você valoriza a flexibilidade do trabalho remoto na sua carreira?",
    yes: "Sim",
    maybe: "Talvez",
    no: "Não",
  },
  work_family_balance: {
    question:
      "Você tem dificuldade em equilibrar o trabalho e o tempo com a família?",
    absolutely: "Absolutamente",
    somewhat: "Um pouco",
    work_life_balance: "Tenho um equilíbrio entre trabalho e vida pessoal",
    prefer_not_to_say: "Prefiro não dizer",
  },
  work_situation: {
    question: "Qual tipo de situação de trabalho você aspira ter?",
    remote_balance: "Equilíbrio remoto",
    stable_routine: "Rotina estável",
    exploring_options: "Estou explorando opções",
  },
  travel_while_working: {
    question: "Você gostaria de poder viajar enquanto trabalha?",
    dream: "É um sonho",
    traveling: "Estou viajando",
    sometimes: "Às vezes",
    not_priority: "Não é uma prioridade",
  },
  content_writing_knowledge: {
    question: "Avalie seu conhecimento em redação de conteúdo",
    upwork_info:
      "De acordo com o Upwork, um redator de conteúdo freelancer ganha cerca de $42.000 anualmente",
    need_more_info: "Preciso de mais informações",
    know_everything: "Eu sei tudo",
  },
  ai_content_creation: {
    question:
      "Você sabia que ferramentas de IA podem tornar a criação de conteúdo ainda mais fácil?",
    no_news: "Não, isso é novidade para mim",
    curious: "Estou curioso",
    heard_of_it: "Sim, já ouvi falar disso",
  },
  digital_marketing_knowledge: {
    question: "Avalie seu conhecimento em marketing digital",
    upwork_info:
      "De acordo com o Upwork, um profissional de marketing digital ganha cerca de $100.000 anualmente.",
    need_more_info: "Preciso de mais informações",
    know_everything: "Eu sei tudo",
  },
  promote_business_ability: {
    question: "Avalie sua habilidade em promover negócios",
    upwork_info:
      "70% dos freelancers encontram seu trabalho online, e você também pode.",
    need_more_info: "Preciso de mais informações",
    know_everything: "Eu sei tudo",
  },
  ai_promotion_help: {
    question:
      "Você sabia que ferramentas de IA podem ajudar você com a promoção?",
    no_news: "Não, isso é novidade para mim",
    curious: "Estou curioso",
    heard_of_it: "Sim, já ouvi falar disso",
  },
  job_interests: {
    question: "Escolha os trabalhos nos quais você pode estar interessado",
    digital_marketing: "Marketing Digital",
    smm: "SMM",
    affiliate_marketing: "Marketing de Afiliados",
    dropshipping: "Dropshipping",
    content_writing: "Redação de Conteúdo",
    copywriting: "Copywriting",
    translation: "Tradução",
    graphic_design: "Design Gráfico",
    blogging: "Blogging",
    illustration: "Ilustração",
    continue: "Continuar",
  },
  freelancing_readiness: {
    question: "Avalie sua prontidão para começar a trabalhar como freelancer",
    need_more_info: "Preciso de mais informações",
    know_everything: "Eu sei tudo",
  },
  freelance_platforms: {
    question: "Plataformas de freelancers das quais você já ouviu falar",
    freelancer: "Freelancer",
    linkedin: "LinkedIn",
    fiverr: "Fiverr",
    guru: "Guru",
    toptal: "Toptal",
    upwork: "Upwork",
    designhill: "Designhill",
    flexjobs: "Flexjobs",
    behance: "Behance",
    wwr: "WWR",
  },
  summary_screen: {
    title: "Resumo do seu <line/> <tag>perfil de freelancer</tag>",
    readiness_score: "Pontuação de Prontidão",
    result_perfect: "Resultado: Perfeito",
    required_score: "Necessário - 75",
    impressive_score:
      "Pontuação impressionante para ter sucesso como freelancer",
    description:
      "Os freelancers desfrutam de maior flexibilidade e potencial de ganho, com 61% deles ganhando mais do que em empregos tradicionais. Você também pode se beneficiar do trabalho freelance.",
    mindset: "MENTALIDADE",
    entrepreneur: "Empreendedor",
    motivation: "MOTIVAÇÃO",
    high: "Alta",
    time_for_freelancing: "TEMPO",
    for_freelancing: "Para freelancing",
    knowledge: "CONHECIMENTO",
    beginner: "Iniciante",
  },
  special_achievement: {
    question: "Há algo especial que você deseja alcançar?",
    options: {
      buy_house: "Comprar uma casa",
      perfect_wedding: "Um casamento perfeito",
      vacation: "Férias",
      buy_car: "Comprar um carro novo",
      retirement: "Aposentadoria tranquila",
    },
    continue: "Continuar",
  },
  time_to_goal: {
    question:
      "Quanto tempo você está disposto a investir para alcançar seu objetivo?",
    options: {
      five_min: "5 min/dia",
      ten_min: "10 min/dia",
      fifteen_min: "15 min/dia",
      twenty_min: "20 min/dia",
    },
  },
  personal_plan: {
    title: "Seu plano pessoal para liberdade de carreira",
    based_on_answers:
      "Com base em suas respostas, esperamos que você adquira as habilidades necessárias para freelancing até",
    confident_freelancer_by: "Freelancer confiante até {{month}}, {{year}}",
    confident: "Confiante",
    freelancer: "Freelancer",
    beginner: "Iniciante",
  },
  designing_plan: {
    title: "Estamos criando seu plano de liberdade de carreira…",
    people_chosen: "Mais de 70.000 pessoas",
    chosen_freelanz_app: "escolheram o Freelanz.app",
    exploring_financial_freedom: "Explorando a Liberdade Financeira",
    essential_guide: "Guia Essencial",
    great_discovery: "Grande Descoberta",
  },
  testimonials: {
    sean: {
      name: "Sean",
      text: "O FreeLanz promove a liberdade financeira através do trabalho freelance. A interface simplificada e as oportunidades diversificadas fazem dele um recurso valioso para novos freelancers como eu.",
    },
    angel: {
      name: "Angel",
      text: "Estou empolgado com minha jornada de aprendizado com o FreeLanz, onde uma ampla gama de tópicos freelance é explorada em seus cursos. A redação publicitária se destaca como a minha favorita.",
    },
    trisha: {
      name: "Trisha",
      text: "O FreeLanz me inspirou a buscar conhecimento em tecnologia e IA, me ajudando a superar minha ansiedade e almejar grandes alturas!",
    },
  },
  email_signup: {
    title:
      "Digite seu e-mail para obter seu plano pessoal de <tag>Liberdade de Carreira</tag>!",
    privacy_note:
      "Respeitamos sua privacidade. Seu e-mail pode tornar a experiência de publicidade mais relevante <tag> Política de Privacidade </tag>.",
    email_label: "Seu E-mail",
    email_placeholder: "Digite um endereço de e-mail válido",
    success_message: "Muito bem!",
  },
  login: {
    title: "Entrar",
    description:
      "Digite seu endereço de e-mail registrado para acessar o aplicativo",
    email_label: "Seu e-mail",
    email_placeholder: "Digite um endereço de e-mail válido",
    login_button: "Entrar",
    no_account: "Não tem uma conta? <tag>Cadastrar</tag>",
  },
  career_plan_ready: {
    title: "Seu Plano de Liberdade de Carreira de 4 semanas está pronto!",
    readiness_level: "Seu nível de prontidão",
    after_4_weeks: "Após 4 semanas",
    now: "Agora",
    week_labels: {
      week_1: "Semana 1",
      week_2: "Semana 2",
      week_3: "Semana 3",
      week_4: "Semana 4",
    },
  },
  otp: {
    title: "Digite o OTP",
    message:
      "Uma senha de uso único foi enviada para seu <tag/> E-mail: {{email}}",
    submit_button: "Enviar",
    resend_otp: "Reenviar OTP",
  },
  payment: {
    email: "e-mail",
    email_placeholder: "Digite um e-mail válido",
    card_number: "NÚMERO DO CARTÃO",
    expires_on: "VALIDADE",
    process_card: "Processar Cartão",
    discount_expires: "Desconto expira em",
    try_now: "TENTE AGORA",
    min: "Min",
    sec: "Seg",
    now: "Agora",
    goal: "Objetivo",
    flexibility: "Flexibilidade",
    earning_power: "Potencial de Ganho",
    limited: "Limitado",
    high: "Alto",
    basic: "Básico",
    disclaimer: "Isso não é uma garantia ou promessa de resultados.",
    trial_offer: "Experimente <tag>FreeLanz 7 dias por $1</tag>, e você irá:",
    // trial_offer: "Experimente o <tag>Freelanz 4 semanas</tag> e irá:",
    benefits: {
      ai_tools: "Domine ferramentas de IA que podem aumentar sua renda",
      additional_sources: "Descubra fontes adicionais de renda",
      skills:
        "Adquira habilidades de um Profissional de Freelance e comece a ganhar",
      beginner_lessons: "Acesso a lições amigáveis para iniciantes",
      guidance: "Orientação para competência e sucesso no freelance",
    },
    trial: "Teste Gratuito de 7 Dias",
    // trial: "PLANO DE 4 SEMANAS",
    payment_methods: "Cartão de Crédito <tag>/</tag> Débito",
    guaranteed_checkout: "Compra <tag>Segura</tag> Garantida",
    what_you_get: "O Que Você Recebe",
    income_know_how: "Conhecimento sobre renda freelance",
    lessons: "Lições informativas, fáceis e divertidas",
    personal_coach:
      "Chat 24/7 com seu treinador pessoal para obter todas as respostas e reduzir erros",
    users_love: "Usuários Amam Nossos Planos",
    user_reviews: {
      review_1:
        "Eu realmente valorizo as lições que vocês fornecem sobre vários assuntos. Estou determinado a ter sucesso nesta área e ganhei insights valiosos. Tem sido uma experiência gratificante e absorvi uma grande quantidade de conhecimento.",
      review_2:
        "Devo reconhecer que este curso está entre os melhores que já fiz. Ele oferece insights práticos sobre o campo do marketing digital.",
      review_3:
        "Esses cursos têm sido excepcionalmente úteis. Nunca encontrei um aplicativo que fornecesse informações tão completas como o Coursiv. O aspecto notável é que estou constantemente aprendendo novas estratégias e táticas para me promover online.",
    },
    career_titles: {
      digital_marketing: "Marketing Digital",
      content_writer: "Redator de Conteúdo",
      graphic_designer: "Designer Gráfico",
    },
    career_info: {
      digital_marketing: "$100,000 por ano",
      content_writer: "$42,000 por ano",
      graphic_designer: "$90,000 por ano",
    },
    no_degree: "Não é necessário ser um profissional",
    no_university_degree: "Não é necessário ter um diploma universitário",
    work_at_your_pace: "Trabalhe no seu próprio ritmo e termos",
    people_often_ask: "Perguntas Frequentes",
    faqs: {
      career_freedom_plan:
        "Sobre o que é o Plano de Liberdade de Carreira e como posso começar?",
      commitment_concerns:
        "Estou preocupado em me comprometer com o freelancing e depois desistir no meio do caminho.",
      technical_skills:
        "É possível aprender freelancing sem habilidades técnicas especializadas?",
    },
    faq_answers: {
      career_freedom_plan:
        "O FreeLanz oferece uma oportunidade para qualquer pessoa se aprofundar no freelancing, fornecendo materiais de aprendizado acessíveis. O Plano de Liberdade de Carreira foca no ensino de habilidades essenciais para freelancers de forma amigável e gamificada, abordando conceitos potencialmente complexos de maneira facilmente compreensível.",
      commitment_concerns:
        "Entendemos suas preocupações, por isso o FreeLanz garante uma experiência amigável para iniciantes. Nosso mentor de IA está disponível para fornecer orientação durante sua jornada, exigindo um esforço mínimo da sua parte.",
      technical_skills:
        "Absolutamente! Nossos recursos de aprendizado são projetados para simplificar tópicos técnicos, tornando-os acessíveis a todos. Embora ter algum conhecimento técnico possa ser benéfico, não é um pré-requisito para o sucesso no freelancing.",
    },
    money_back_guarantee: "Garantia de Reembolso de 100%",
    guarantee_message:
      "Acreditamos que nosso plano pode funcionar para você e que você obterá resultados em 4 semanas! Estamos dispostos a devolver seu dinheiro se você não ver resultados, mas isso depende principalmente de você. Por favor, verifique nossa <tag>Política de Reembolso</tag> para entender todos os requisitos.",
  },
};
